import type { Dict } from "../core.js";
import type { sharedHub as vi } from "../vi/sharedHub.js";

export const sharedHub: Dict<typeof vi> = {
  "policy.strict.label": "Strict",
  "policy.strict.body":
    "Every account claim requires a 2,000đ transfer FROM that same account to prove ownership. The safest option.",
  "policy.lenient.label": "Lenient",
  "policy.lenient.body":
    "The FIRST claim of an account number connects immediately, with no transfer — as long as no other company has ever claimed it and the shared hub has never seen notifications for it. Duplicate claims still require verification; the last one to verify wins.",
  title: "Shared hub — claim policy",
  subtitle:
    "bube-banktransfer customers share balance notifications to bube's device, then claim their account number on the dashboard. This policy decides which claims need a 2,000đ verification transfer.",
  loadFailed: "Couldn't load the claim policy.",
  saveFailed: "Couldn't change the claim policy.",
  hubLabel: "Shared hub: ",
  open: "OPEN to customers",
  closed: "CLOSED",
  openHint: " — customers see « Share notifications » on the bube-banktransfer dashboard and can claim accounts.",
  closedHint:
    " — customers don't see « Share notifications ». Hub devices still receive notifications but don't route them to new claims.",
  changing: "Changing…",
  confirmClose: "Confirm CLOSE to customers",
  confirmOpen: "Confirm OPEN to customers",
  closeForCustomers: "Close to customers",
  openForCustomers: "Open to customers",
  activeLabel: "Active: ",
  defaultUntouched: " · default, never changed",
  changedAt: "· changed {at}",
  changedBy: " by {who}",
  lenientRisk:
    "Risk: anyone who knows a store's account number (printed on the QR at the counter) can claim it BEFORE the store shares, and see its incoming payments until the real owner verifies. The money still goes to the store's account; what leaks is transaction information.",
  confirmSwitch: "Confirm switch to « {policy} »",
  switchTo: "Switch to « {policy} »",
  ownerOnly: "Only the owner role can change the claim policy.",
  downgradeNote:
    "Switching from « Lenient » to « Strict » doesn't revoke accounts already connected on first claim — it only applies to future claims.",

  "apk.title": "Internal « Bube Bank Transfer Hub » APK",
  "apk.body":
    "The installer for bube's shared hub devices — it can read balance notifications of EVERY customer sharing to the device. Developers only; customers have no way to download it. Installed hub devices update themselves; download only when setting up a new device.",
  "apk.loadFailed": "Couldn't get the download link.",
  "apk.notConfigured": "bube-banktransfer hasn't configured the release store (R2) in this environment.",
  "apk.noRelease": "No hub release published yet.",
  "apk.version": "Version ",
  "apk.meta": " (code {code}) · {size} MB · released {at}",
  "apk.download": "Download {file}",
  "apk.expires": "Link expires at {at} — get a new one after that.",
  "apk.fetching": "Getting link…",
  "apk.fetch": "Get APK download link",

  "devices.title": "Hub devices",
  "devices.intro.pre":
    "Android devices running « Bube Bank Transfer Hub » receive the balance notifications customers share. A device pairs with a code into the bube-banktransfer system workspace",
  "devices.intro.post": ", and must be approved here before it receives notifications.",
  "devices.loadFailed": "Couldn't load hub devices.",
  "devices.codeFailed": "Couldn't create a pairing code.",
  "devices.decideFailed": "Couldn't save the decision.",
  "devices.creatingCode": "Creating code…",
  "devices.createCode": "Create hub pairing code",
  "devices.code": "Code: ",
  "devices.codeExpires": " · expires {at}",
  "devices.ownerOnly": "Only the owner role can create pairing codes and approve hub devices.",
  "devices.pairHint": "On the hub device: open Bube Bank Transfer Hub → enter the code. It will appear below as « Pending approval ».",
  "devices.loading": "Loading…",
  "devices.empty": "No hub devices yet.",
  "col.device": "Device",
  "col.paired": "Paired · IP",
  "col.heartbeat": "Heartbeat",
  "col.listening": "Listening",
  "col.status": "Status",
  noHeartbeat: "none yet",
  unknownBank: " · unknown bank",
  lastNotification: "last notification {at}",
  noNotification: "no notifications yet",
  "status.pending": "Pending approval",
  "status.rejected": "Rejected",
  "status.revoked": "Removed",
  "status.live": "Running",
  "status.stale": "No heartbeat > 60 min",
  "confirm.approve": "Approve ⇒ this device can read balance notifications of every customer sharing to it. Are you sure?",
  "confirm.reject": "Reject ⇒ the device is removed and must re-pair with a new code.",
  "confirm.revoke":
    "Remove ⇒ the device stops receiving notifications immediately; banks only this device listens to will be temporarily closed to customers. Re-pairing needs a new code.",
  "action.approve": "Approve",
  "action.reject": "Reject",
  "action.revoke": "Remove",
  "action.approveEllipsis": "Approve…",
  "action.rejectEllipsis": "Reject…",
  "action.revokeEllipsis": "Remove…",
  // HQ-2026-007 — bube-banktransfer status pill in the header.
  "svc.name": "BankTransfer",
  "svc.online": "Online",
  "svc.offline": "Offline",
  "svc.rejected": "Hub rejected",
  "svc.notConfigured": "Not configured",
  "svc.checking": "Checking…",
  "svc.unknown": "Unreadable",
  "svc.devices": "{online}/{total} hub phones online",
  "svc.title.online": "bube-banktransfer server answered ({ms} ms). Hub phones: {online} online · {offline} offline (silent over {window} min) · {pending} pending. Checked at {at}.",
  "svc.title.down": "{reason} Checked at {at}.",
  "svc.title.unknown": "The hub could not read the status: {reason}",
  "svc.cardTitle": "Service status",
};
